import React from "react";
import * as styles from "./menu-loader.module.scss";

export const MenuLoader = () => (
  <div className={styles.wrapper}>
    {[1, 2, 3].map((section) => (
      <div key={section} className={styles.card}>
        <div className={styles.title} />
        {[1, 2, 3, 4].map((row) => (
          <div key={row} className={styles.row} />
        ))}
      </div>
    ))}
  </div>
);
